import { AnyAction, Reducer, combineReducers, configureStore } from "@reduxjs/toolkit";
import { appReducer, appSlice } from "./slices/appSlice";
import { sessionReducer, sessionSlice } from "./slices/sessionSlice";
import { Session } from "../session/session";
import { costCenterReducer, costCenterSlice } from "./slices/costCenterSlice";
import { transportReducer, transportSlice } from "./slices/transportSlice";
import { salaryPeriodReducer, salaryPeriodSlice } from "./slices/salaryPeriodSlice";
import { workHoursReducer, workHoursSlice } from "./slices/workHoursSlice";
import { workShiftTimeSlotReducer, workShiftTimeSlotSlice } from "./slices/workShiftTimeSlotSlice";
import { vehicleReducer, vehicleSlice } from "./slices/vehicleSlice";
import { transportPlanReducer, transportPlanSlice } from "./slices/transportPlanSlice";
import { transportOrderReducer, transportOrderSlice } from "./slices/transportOrderSlice";
import { transportOrderDetailsReducer, transportOrderDetailsSlice } from "./slices/transportOrderDetailsSlice";
import { customerReducer, customerSlice } from "./slices/customerSlice";
import { dayBookingReducer, dayBookingSlice } from "./slices/dayBookingSlice";
import { workShiftReducer, workShiftSlice } from "./slices/workShiftSlice";
import { calendarReducer, calendarSlice } from "./slices/calendarSlice";
import { productReducer, productSlice } from "./slices/productSlice";
import { notificationReducer, notificationSlice } from "./slices/notificationSlice";
import { plannedWorkShiftReducer, plannedWorkShiftSlice } from "./slices/plannedWorkShiftSlice";

const combinedReducer = combineReducers({
    [appSlice.name]: appReducer,
    [sessionSlice.name]: sessionReducer,
    [costCenterSlice.name]: costCenterReducer,
    [transportPlanSlice.name]: transportPlanReducer,
    [transportSlice.name]: transportReducer,
    [transportOrderSlice.name]: transportOrderReducer,
    [transportOrderDetailsSlice.name]: transportOrderDetailsReducer,
    [salaryPeriodSlice.name]: salaryPeriodReducer,
    [workHoursSlice.name]: workHoursReducer,
    [workShiftTimeSlotSlice.name]: workShiftTimeSlotReducer,
    [workShiftSlice.name]: workShiftReducer,
    [vehicleSlice.name]: vehicleReducer,
    [customerSlice.name]: customerReducer,
    [dayBookingSlice.name]: dayBookingReducer,
    [calendarSlice.name]: calendarReducer,
    [productSlice.name]: productReducer,
    [notificationSlice.name]: notificationReducer,
    [plannedWorkShiftSlice.name]: plannedWorkShiftReducer,
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
    if (action.type === "app/clearStore") {
        state = {} as RootState;
    }
    return combinedReducer(state, action);
};

// Store provided for App
export const store = configureStore({
    reducer: rootReducer
});

// Test helper fn to setup store using actual reducers. Provide preloadedState to alter initial state
export const setupStore = (preloadedState) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState
    });
};

export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = typeof store.dispatch;

void Session.getSessionState().then((i) => {
    if (!i) return;
    store.dispatch(sessionSlice.actions.setSession({ ...i }));
});
